import React from 'react';
import { Button, Col, Row } from '@thd-olt-component-react/core-ui';
import { useNavigate } from '@thd-olt-component-react/router';
import PtpRichTextEditor from '../../../../components/common/PtpRichTextEditor/PtpRichTextEditor';
import { EXP_ROUTES } from '../../../../utils/constants';

export const JobTemplateDetails = ({ jobTemplate }) => {
  const navigate = useNavigate();

  const renderTemplate = () => {
    return (
      <Row>
        <Col xs={12} sm={8} md={8} lg={8} fallback={12} className="ptp-job-template__template-background-container">
          <div className="ptp-job-template__template-background">
            <div className="ptp-job-template__template-bold">
              Job Description
            </div>
            <div className="ptp-job-template__template-text">
              <PtpRichTextEditor
                key={jobTemplate?.jobTemplateId}
                jobDescriptionHTML={jobTemplate?.jobDescription}
                placeholder="This job template has no job description saved"
                readOnly
              />
            </div>
            <div className="ptp-job-template__template-bold">
              Required Education and Skills
            </div>
            <div className="ptp-job-template__template-text ptp-job-template__template-line-breaks">
              {jobTemplate?.educationAndSkills}
            </div>
          </div>
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} fallback={12} className="ptp-job-template__template-button-container">
          <Button
            className="ptp-job-template__details-button"
            onClick={() => {
              navigate(EXP_ROUTES.CREATE_JOB_POSTING, { state: { jobTemplate } });
            }}
          >
            Use Template
          </Button>
        </Col>
      </Row>

    );
  };

  return (
    <>
      {renderTemplate()}
    </>
  );
};
